import { RESOLUTION_1M, RESOLUTION_1W, RESOLUTION_24H, RESOLUTION_1H, RESOLUTION_10MIN } from './app';

import { makeZoomOptions, makeMAvgOptions } from '../utils/other';

export const MOVING_MATH_DAYS = [0, 7, 14, 30, 50, 90];
export const MOVING_MATH_HOURS = [0, 3, 6, 12, 24, 48, 72, 96, 120];
export const MOVING_MATH_MINUTES = [0, 30, 50, 120, 180, 240, 300];
export const MOVING_MATH_WEEKS = [0, 2, 4, 6, 8, 10, 12];
export const MOVING_MATH_MONTHS = [0, 2, 4, 6, 8, 10, 12];
export const MOVING_MATH_DAYS_OPTIONS = makeMAvgOptions(MOVING_MATH_DAYS, 'Days');
export const MOVING_MATH_HOURS_OPTIONS = makeMAvgOptions(MOVING_MATH_HOURS, 'Hours');
export const MOVING_MATH_MINUTES_OPTIONS = makeMAvgOptions(MOVING_MATH_MINUTES, 'Minutes');
export const MOVING_MATH_WEEKS_OPTIONS = makeMAvgOptions(MOVING_MATH_WEEKS, 'Weeks');
export const MOVING_MATH_MONTHS_OPTIONS = makeMAvgOptions(MOVING_MATH_MONTHS, 'Months');
export const MOVING_MATH_VALID_RANGE = [0, 1000];
export const MOVING_MATH_MINUTES_VALID_RANGE = [10, 1000];

export const ZOOM_OPTIONS = makeZoomOptions();
export const ZOOM_OPTIONS_TIER_1 = makeZoomOptions(['7', '14', '30']);
export const ZOOM_OPTIONS_TIER_2 = makeZoomOptions(['7', '14', '30']);
export const ZOOM_OPTIONS_TIER_3 = makeZoomOptions(['7', '14', '30', '90', '182', 'ytd', '365']);

export const RESOLUTION_OPTIONS = [
  {
    value: RESOLUTION_1M,
    label: '1 Month',
  },
  {
    value: RESOLUTION_1W,
    label: '1 Week',
  },
  {
    value: RESOLUTION_24H,
    label: '1 Day',
  },
  {
    value: RESOLUTION_1H,
    label: '1 Hour',
  },
  {
    value: RESOLUTION_10MIN,
    label: '10 Minutes',
    tooltip: 'View limited to 1 year. Full history available through API.',
  },
];
